import "./EmployeeSignup.css";
import React from "react";
import ContentItem from "shared/components/cms/ContentItem";
import { URLS } from "util/constants";

class EmployeeSignup extends React.Component {
    render() {
        const contentArgs = {
            highlightClassName: "highlighted"
        };
        return (
            <div className="employee-signup-body">
                <ContentItem tag="h2" className="signup-header" sharedKey="employeeSignup" contentKey="signupHeader" stringFormatArgs={contentArgs} />
                <ContentItem tag="p" className="signup-subheader" sharedKey="employeeSignup" contentKey="signupSubheader" />
                <button className="btn-signup" onClick={() => { window.open(URLS.GO, "_blank"); }} >
                    <ContentItem tag="span" sharedKey="employeeSignup" contentKey="letsGoBtnText" />
                </button>
            </div>
        );
    }
}

export default EmployeeSignup;